<section class="flex justify-between mb-3">
    <h1 class="text-2xl font-bold text-gray-800">Configuración</h1>
</section>

<div class="grid grid-cols-1 md:grid-cols-5 gap-6">

    <section class="md:col-span-2 md:order-1 bg-white p-6 rounded-xl shadow-sm border border-gray-100">
        <section class="flex justify-between items-center mb-3">
            <h2 class="text-sm font-semibold uppercase tracking-wider text-indigo-500">
                Tarifas
            </h2>
            <add-button label="Gestionar Tarifas" (onClick)="openTariffForm()"></add-button>
        </section>

        @if(tariffs){
        <div class="space-y-6">
            <!-- @if(tariffs.ticket_tariff && tariffs.ticket_tariff != 0){
            <div class="flex items-center justify-between p-4 bg-indigo-50 rounded-lg border border-indigo-100">
                <div>
                    <p class="text-xs text-indigo-600 font-medium uppercase">Tarifa de Ticket (Porcentaje)</p>
                    <p class="text-xl font-bold text-indigo-900">
                        {{tariffs.ticket_tariff}}
                        <small class="text-xs text-gray-400">IVA incluido</small>
                    </p>

                </div>
            </div>
            } -->

            <div>
                <h3 class="text-xs font-medium text-gray-500 uppercase mb-3 px-1">Porcentajes de Facturación</h3>
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    @for (invoice_tariff of dropdowns.tariffs; track $index) {
                    <div
                        class="p-3 bg-gray-50 rounded-lg border border-gray-100 hover:border-indigo-200 transition-colors">
                        <span class="text-gray-400 mr-3 font-bold">
                            {{ invoice_tariff.name || `Tarifa ${$index + 1}` }}
                        </span>
                        <div class="flex  gap-2 items-center">
                            <span class="text-xs text-gray-400">Porcentaje</span>
                            <span class="text-sm font-semibold text-gray-700">{{invoice_tariff.quotient}}</span>
                        </div>
                    </div>
                    } @empty {
                    <div class="col-span-full py-4 text-center text-gray-400 text-sm italic">
                        No hay porcentaje configurados.
                    </div>
                    }
                </div>
            </div>
        </div>
        } @else {
        <div class="flex flex-col items-center justify-center py-8 text-gray-400">
            <p class="text-sm">Cargando tarifas...</p>
        </div>
        }


        <!-- <sau-table #tariffTable [url]="urlTariffs" contentList="list" contentTotal="count" pageParamName="page"
            [sizeInitialPage]="1" limitParamName="limit" [sizeBetweenPages]="1" [limit]="10"
            [headers]="headers"></sau-table> -->


    </section>

    <section class="md:col-span-3 md:order-1 bg-white p-6 rounded-xl shadow-sm border border-gray-100">
        <section class="flex justify-between items-center mb-3">
            <h2 class="text-sm font-semibold uppercase tracking-wider text-indigo-500">
                Tipos de IVA
            </h2>
            <add-button label="Gestionar Tipos de IVA" (onClick)="openTaxForm()"></add-button>
        </section>

        @if(dropdowns.taxes && dropdowns.taxes.length > 0){
        <div class="space-y-6">
            <div>
                <h3 class="text-xs font-medium text-gray-500 uppercase mb-3 px-1">Tipos de IVA</h3>
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">

                    @for (tax of dropdowns.taxes; track $index) {
                    <div
                        class="p-3 bg-gray-50 rounded-lg border border-gray-100 hover:border-indigo-200 transition-colors">
                        <span class="text-gray-400 mr-3 font-bold">
                            IVA {{ $index + 1 }}
                        </span>
                        <div class="flex  gap-2 items-center">
                            <span class="text-xs text-gray-400">IVA</span>
                            <span class="text-sm font-semibold text-gray-700">{{tax.quotient}}%</span>
                        </div>
                    </div>
                    } @empty {
                    <div class="col-span-full py-4 text-center text-gray-400 text-sm italic">
                        No hay IVA configurados.
                    </div>
                    }
                </div>
            </div>
        </div>
        } @else {
        <div class="flex flex-col items-center justify-center py-8 text-gray-400">
            <p class="text-sm">Cargando Tipos de IVA...</p>
        </div>
        }
    </section>

    <!-- <section class="md:col-span-3 md:order-1 bg-white p-6 rounded-xl shadow-sm border border-gray-100">
        <section class="flex justify-between items-center mb-3">
            <h2 class="text-sm font-semibold uppercase tracking-wider text-indigo-500">
                Métodos de Pago
            </h2>
            <add-button label="Gestionar Métodos de Pago" (onClick)="openPaymentMethodForm()"></add-button>
        </section>
        @if(dropdowns.payMethods){
        <div class="space-y-6">
            <div>
                <h3 class="text-xs font-medium text-gray-500 uppercase mb-3 px-1">Métodos de Pago</h3>
                <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">

                    @for (pay_method of dropdowns.payMethods; track $index) {
                    <div
                        class="p-3 bg-gray-50 rounded-lg border border-gray-100 hover:border-indigo-200 transition-colors">
                        <span class="text-gray-400 mr-3 font-bold">
                            Pago {{ $index + 1 }}
                        </span>
                        <div class="flex  gap-2 items-center">
                            <span class="text-xs text-gray-400">Pago</span>
                            <span class="text-sm font-semibold text-gray-700">{{pay_method.name}}</span>
                        </div>
                    </div>
                    } @empty {
                    <div class="col-span-full py-4 text-center text-gray-400 text-sm italic">
                        No hay Métodos de Pago configurados.
                    </div>
                    }
                </div>
            </div>
        </div>
        } @else {
        <div class="flex flex-col items-center justify-center py-8 text-gray-400">
            <p class="text-sm">Cargando Métodos de Pago...</p>
        </div>
        }
    </section> -->

    <section class="md:col-span-3 md:order-1 bg-white p-6 rounded-xl shadow-sm border border-gray-100">
        <section class="flex justify-between items-center mb-4">
            <h2 class="text-sm font-semibold uppercase tracking-wider text-indigo-500">
                Oficinas
            </h2>
            <add-button label="Nueva Oficina" (onClick)="openOfficeForm()"></add-button>
        </section>

        @if(offices.length > 0){
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
            @for (office of offices; track office.id) {
            <div
                class="p-4 bg-gray-50 rounded-lg border border-gray-100 hover:border-indigo-200 transition-colors group">
                <div class="flex justify-between items-start">
                    <div>
                        <p class="text-sm font-semibold text-gray-800">{{ office.name }}</p>
                        <div class="flex gap-3 mt-1">
                            @if(office.prefix){
                            <span class="text-xs text-gray-400">Prefijo: <span
                                    class="font-mono font-medium text-gray-600">{{ office.prefix }}</span></span>
                            }
                            @if(office.sequence_start){
                            <span class="text-xs text-gray-400">Desde: <span
                                    class="font-medium text-gray-600">{{ office.sequence_start }}</span></span>
                            }
                            @if(office.sequence_start_refund){
                            <span class="text-xs text-gray-400">Desde (abono): <span
                                    class="font-medium text-gray-600">{{ office.sequence_start_refund }}</span></span>
                            }
                        </div>
                    </div>
                    <div class="flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                        <button type="button" (click)="openOfficeForm(office)"
                            class="p-1.5 text-indigo-400 hover:bg-indigo-50 rounded-lg transition-colors">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                                stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                            </svg>
                        </button>
                        <button type="button" (click)="openOfficeDeleteForm(office)"
                            class="p-1.5 text-red-400 hover:bg-red-50 rounded-lg transition-colors">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                                stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
            }
        </div>
        } @else {
        <div
            class="flex flex-col items-center justify-center py-8 text-center border-2 border-dashed border-gray-100 rounded-lg">
            <svg class="w-10 h-10 text-gray-200 mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                    d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
            </svg>
            <p class="text-gray-400 italic text-sm">No hay oficinas registradas.</p>
        </div>
        }

    </section>

    <section class="md:col-span-3 md:order-1 bg-white p-6 rounded-xl shadow-sm border border-gray-100">
        <section class="flex justify-between items-center mb-4">
            <h2 class="text-sm font-semibold uppercase tracking-wider text-indigo-500">
                Tablets
            </h2>
            <add-button label="Emparejar Tablet" (onClick)="openTabletPairingForm()"></add-button>
        </section>

        <p class="text-xs text-gray-400 mb-4">
            Pantallas de firma remota (<span class="font-mono">/tablet-sign</span>). Cada tablet queda ligada a una oficina y solo recibe documentos de esa oficina.
        </p>

        @if(tablets.length > 0){
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
            @for (tablet of tablets; track tablet.id) {
            <div class="p-4 bg-gray-50 rounded-lg border border-gray-100 hover:border-indigo-200 transition-colors group">
                <div class="flex justify-between items-start">
                    <div>
                        <div class="flex items-center gap-1.5">
                            <span class="h-1.5 w-1.5 rounded-full" [class.bg-green-500]="tablet.online" [class.bg-gray-300]="!tablet.online"></span>
                            <p class="text-sm font-semibold text-gray-800">{{ tablet.name }}</p>
                        </div>
                        <div class="flex gap-3 mt-1">
                            <span class="text-xs text-gray-400">{{ tablet.office?.name || 'Sin oficina' }}</span>
                            <span class="text-xs" [class.text-green-600]="tablet.online" [class.text-gray-400]="!tablet.online">
                                {{ tablet.online ? 'En línea' : 'Desconectada' }}
                            </span>
                        </div>
                    </div>
                    <div class="flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                        <button type="button" (click)="openTabletDeleteForm(tablet)"
                            class="p-1.5 text-red-400 hover:bg-red-50 rounded-lg transition-colors">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24"
                                stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
            }
        </div>
        } @else {
        <div
            class="flex flex-col items-center justify-center py-8 text-center border-2 border-dashed border-gray-100 rounded-lg">
            <p class="text-gray-400 italic text-sm">No hay tablets emparejadas.</p>
        </div>
        }
    </section>

    <section class="md:col-span-3 md:order-1 bg-white p-6 rounded-xl shadow-sm border border-gray-100">
        <section class="flex justify-between items-center mb-4">
            <h2 class="text-sm font-semibold uppercase tracking-wider text-indigo-500">
                Dispositivo de respaldo offline
            </h2>
            <add-button label="Designar ordenador" (onClick)="openDocumentDeviceForm()"></add-button>
        </section>

        <p class="text-xs text-gray-400 mb-4">
            Si se pierde la conexión a internet, solo el ordenador designado aquí podrá seguir generando documentos, tickets y compras.
        </p>

        @if (documentDeviceMonitor.status(); as status) {
        <div class="p-4 bg-gray-50 rounded-lg border border-gray-100 flex justify-between items-start max-w-sm">
            <div>
                <div class="flex items-center gap-1.5">
                    <span class="h-1.5 w-1.5 rounded-full" [class.bg-green-500]="!documentDeviceMonitor.isStale(status)" [class.bg-gray-300]="documentDeviceMonitor.isStale(status)"></span>
                    <p class="text-sm font-semibold text-gray-800">{{ status.name }}</p>
                    @if (documentDeviceService.readIdentity()?.name === status.name) {
                    <span class="text-[10px] text-indigo-500 font-semibold uppercase">(este ordenador)</span>
                    }
                </div>
                <span class="text-xs" [class.text-green-600]="!documentDeviceMonitor.isStale(status)" [class.text-gray-400]="documentDeviceMonitor.isStale(status)">
                    {{ documentDeviceMonitor.isStale(status) ? 'Sin señal reciente' : 'En línea' }}
                </span>
            </div>
        </div>
        } @else {
        <div
            class="flex flex-col items-center justify-center py-8 text-center border-2 border-dashed border-gray-100 rounded-lg">
            <p class="text-gray-400 italic text-sm">No se ha detectado ningún ordenador designado todavía.</p>
        </div>
        }
    </section>

    <section class="md:col-span-2 md:order-1 bg-white p-6 rounded-xl shadow-sm border border-gray-100">
        <section class="flex justify-between items-center mb-4">
            <h2 class="text-sm font-semibold uppercase tracking-wider text-indigo-500">
                Correo IMAP
            </h2>
            <add-button label="Configurar" (onClick)="openImapForm()"></add-button>
        </section>

        <p class="text-xs text-gray-400 mb-4">
            Cuenta desde la que se guardarán los borradores de facturas para envío manual.
        </p>
    </section>

    <section class="md:col-span-2 md:order-1 bg-white p-6 rounded-xl shadow-sm border border-gray-100">
        <section class="flex justify-between items-center mb-4">
            <h2 class="text-sm font-semibold uppercase tracking-wider text-indigo-500">
                Verifactu
            </h2>
            <add-button label="Configurar" (onClick)="openVerifactuForm()"></add-button>
        </section>

        <p class="text-xs text-gray-400 mb-4">
            Certificado digital y modo de envío de facturas a Verifactu/AEAT.
        </p>
    </section>

    <section class="md:col-span-2 md:order-1 bg-white p-6 rounded-xl shadow-sm border border-gray-100">
        <section class="flex justify-between items-center mb-4">
            <h2 class="text-sm font-semibold uppercase tracking-wider text-indigo-500">
                Clientes Varios
            </h2>
        </section>

        <p class="text-xs text-gray-400 mb-4">
            Selecciona los clientes varios.
        </p>

        <custom-select
            label="Clientes"
            placeholder="BUSCAR CLIENTE..."
            [formControlItem]="specialClientsControl"
            [isMultiple]="true"
            [options]="dropdowns.clients"
            bindValue="id"
            bindLabel="name"
            [createComponent]="clientFormComponent"
            (itemCreated)="getDropdowns()">
        </custom-select>

        <div class="mt-4 flex justify-end">
            <button type="button" (click)="saveSpecialClients()"
                [disabled]="savingSpecialClients"
                class="px-4 py-2 bg-indigo-600 text-white text-xs font-semibold uppercase tracking-wider rounded-lg hover:bg-indigo-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
                {{ savingSpecialClients ? 'Guardando...' : 'Guardar' }}
            </button>
        </div>
    </section>

    <section class="md:col-span-5 md:order-1 bg-white p-6 rounded-xl shadow-sm border border-gray-100">
        <section class="flex justify-between items-center mb-4">
            <h2 class="text-sm font-semibold uppercase tracking-wider text-indigo-500">
                Plantillas e Imágenes
            </h2>
            <div class="flex gap-2">
                <button type="button" (click)="toogleTemplateSettingsList()"
                    class="px-3 py-1.5 text-xs font-semibold uppercase tracking-wider text-indigo-600 border border-indigo-200 rounded-lg hover:bg-indigo-50 transition-colors">
                    {{ templateSettingsShowList ? 'Ocultar' : 'Ver' }}
                </button>
                <add-button label="Añadir Plantilla" (onClick)="openTemplateSettingsForm()"></add-button>
            </div>
        </section>

        <div class="flex items-start gap-2 mb-4 p-3 bg-amber-50 border border-amber-200 rounded-lg">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-amber-500 mt-0.5 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z" />
            </svg>
            <p class="text-xs text-amber-700">
                <span class="font-semibold">Importante:</span> para que funcione al añadir es necesario la manipulación de soporte técnico.
            </p>
        </div>

        @if(templateSettingsShowList){
        <div class="mt-2">
            @if(templateSettings.length > 0){
            <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
                @for (tmpl of templateSettings; track tmpl.id) {
                <div
                    class="p-4 bg-gray-50 rounded-lg border border-gray-100 hover:border-indigo-200 transition-colors group">
                    <div class="flex justify-between items-start">
                        <div class="min-w-0 flex-1">
                            <p class="text-sm font-semibold text-gray-800 truncate">{{ tmpl.label || tmpl.short_code }}</p>
                            <div class="flex flex-wrap gap-2 mt-1">
                                <span class="text-xs font-mono text-indigo-600 bg-indigo-50 px-1.5 py-0.5 rounded">{{ tmpl.short_code }}</span>
                                @if(tmpl.type){
                                <span class="text-xs text-gray-400 bg-gray-100 px-1.5 py-0.5 rounded uppercase">{{ tmpl.type }}</span>
                                }
                                <span class="text-xs px-1.5 py-0.5 rounded"
                                    [class.bg-green-50]="tmpl.is_active" [class.text-green-600]="tmpl.is_active"
                                    [class.bg-red-50]="!tmpl.is_active" [class.text-red-500]="!tmpl.is_active">
                                    {{ tmpl.is_active ? 'Activa' : 'Inactiva' }}
                                </span>
                            </div>
                            <p class="text-xs text-gray-400 mt-1 truncate" title="{{ tmpl.path }}">{{ tmpl.path }}</p>
                        </div>
                        <div class="flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity ml-2">
                            <button type="button" (click)="openTemplateSettingsForm(tmpl)"
                                class="p-1.5 text-indigo-400 hover:bg-indigo-50 rounded-lg transition-colors">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                </svg>
                            </button>
                            <button type="button" (click)="deleteTemplateSetting(tmpl)"
                                class="p-1.5 text-red-400 hover:bg-red-50 rounded-lg transition-colors">
                                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
                }
            </div>
            } @else {
            <div
                class="flex flex-col items-center justify-center py-8 text-center border-2 border-dashed border-gray-100 rounded-lg">
                <svg class="w-10 h-10 text-gray-200 mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                        d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                <p class="text-gray-400 italic text-sm">No hay plantillas registradas.</p>
            </div>
            }
        </div>
        }

    </section>

    <!-- <section class="md:col-span-2 md:order-3 bg-white p-6 rounded-xl shadow-sm border border-gray-100">
        <h2 class="text-sm font-semibold uppercase tracking-wider mb-4 text-indigo-500">Ubicación y
            Contacto</h2>

        @if(company.address || company.phone || company.phone_2){
        <div class="grid grid-cols-1 sm:grid-cols-2 gap-6">
            @if(company.address){
            <div class="sm:col-span-2">
                <p class="text-sm text-gray-500">Dirección</p>
                <p class="text-gray-900 font-medium">{{company.address}}</p>
                <p class="text-sm text-gray-600">{{company.postal_code}} {{company.city}} ({{company.province}})</p>
            </div>
            }
            @if(company.phone){
            <div>
                <p class="text-sm text-gray-500">Teléfono Principal</p>
                <p class="text-gray-900 font-medium">{{company.phone}}</p>
            </div>
            }
            @if(company.phone_2){
            <div>
                <p class="text-sm text-gray-500">Teléfono Secundario</p>
                <p class="text-gray-900 font-medium">{{company.phone_2}}</p>
            </div>
            }
        </div>
        } @else {
        <div
            class="flex flex-col items-center justify-center py-8 text-center border-2 border-dashed border-gray-50 rounded-lg">
            <svg class="w-12 h-12 text-gray-200 mb-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                    d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"
                    d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
            <p class="text-gray-400 italic text-sm">No hay datos de contacto registrados.</p>
        </div>
        }
    </section>

    <section class="md:order-2 bg-white p-6 rounded-xl shadow-sm border border-gray-100">
        <h3 class="text-indigo-600 text-xs font-bold uppercase tracking-widest mb-4">Facturación</h3>
        <div class="space-y-4 text-sm">
            <div>
                <span class="text-gray-500 block mb-1">IBAN de la cuenta:</span>
                @if(company.iban){
                <span class="font-mono font-medium text-gray-800 break-all uppercase">{{company.iban}}</span>
                } @else {
                <span class="italic text-gray-400 text-xs">No configurado</span>
                }
            </div>
            <div class="pt-2 border-t border-gray-50">
                <span class="text-gray-500 block mb-1">Prefijo de Factura:</span>
                <span class="font-medium text-gray-800">{{company.invoices_prefix || 'Por defecto'}}</span>
            </div>
        </div>
    </section>

    <section class="md:order-4 flex flex-col bg-gray-50 p-6 rounded-xl border border-gray-200">
        <h3 class="text-gray-500 text-xs font-bold uppercase tracking-widest mb-4">Sistema</h3>
        <ul class="space-y-3 text-sm">
            <li class="flex justify-between items-center">
                <span class="text-gray-500">Estado:</span>
                <span class="flex items-center gap-1.5 font-semibold" [class.text-green-600]="company.is_active"
                    [class.text-red-600]="!company.is_active">
                    <span class="h-1.5 w-1.5 rounded-full" [class.bg-green-500]="company.is_active"
                        [class.bg-red-500]="!company.is_active"></span>
                    {{company.is_active ? 'Activa' : 'Inactiva'}}
                </span>
            </li>
        </ul>

        <div class="mt-auto flex justify-between pt-2 border-t border-gray-200">
            <span class="text-gray-500 text-xs text-right w-full italic">Actualizado: {{company.updated_at |
                date: 'dd/MM/yy HH:mm'}}</span>
        </div>
    </section> -->

</div>